import {Directive, forwardRef, Injectable} from '@angular/core';
import {
  AbstractControl,
  AsyncValidator,
  NG_ASYNC_VALIDATORS,
  ValidationErrors,
} from '@angular/forms';
import {catchError, map} from 'rxjs/operators';
import {AuthService} from '@auth-module/auth.service';
import {Observable, of} from 'rxjs';
import {LogService} from '@aam/angular-logging';

@Injectable({providedIn: 'root'})
export class EmailUniqueValidator implements AsyncValidator {
  constructor(private authService: AuthService, private logger: LogService) {}

  exeptId = 0;

  validate(
    ctrl: AbstractControl
  ): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    if (ctrl.value === '') return of(null);
    if (this.exeptId === 0) {
      return this.authService.emailExists(ctrl.value).pipe(
        map(emailFound => (emailFound ? {emailExists: true} : null)),
        catchError(e => {
          this.logger.error('Failed to validate email: ', e);
          return null;
        })
      );
    } else {
      return this.authService.emailExistsExcept(ctrl.value, this.exeptId).pipe(
        map(emailFound => (emailFound ? {emailExists: true} : null)),
        catchError(e => {
          this.logger.error('Failed to validate email: ', e);
          return null;
        })
      );
    }
  }
}

@Directive({
  selector: '[appEmailUnique]',
  providers: [
    {
      provide: NG_ASYNC_VALIDATORS,
      useExisting: forwardRef(() => EmailUniqueValidator),
      multi: true,
    },
  ],
})
export class EmailUniqueValidatorDirective {
  constructor(private validator: EmailUniqueValidator) {}

  validate(control: AbstractControl) {
    this.validator.validate(control);
  }
}
